<template>
  <div class="list-section">
    <div class="search-bg">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm">
        <!-- 第一行 -->
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text88') + '：'"
              class="search-label"
            >
              <el-input v-model="searchForm.name" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="agentConfig.emailLoginReg">
            <el-form-item
              :label="$t('proxy.text34') + '：'"
              class="search-label"
            >
              <el-input v-model="searchForm.email" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="agentConfig.phoneLoginReg">
            <el-form-item
              :label="$t('proxy.text89') + '：'"
              class="search-label"
            >
              <el-input v-model="searchForm.phone" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text111') + '：'"
              class="search-label"
            >
              <el-input v-model="searchForm.fundAccountId" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text216') + '：'"
              class="search-label"
            >
              <el-input v-model="searchForm.mt4LoginId" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text62') + '：'"
              class="search-label"
            >
              <el-select
                clearable
                v-model="searchForm.SProxyId"
                placeholder=""
                :popper-options="popperOptions"
                :teleported="true"
                popper-append-to-body
              >
                <el-option
                  v-for="agent in agents"
                  :key="agent.proxyId"
                  :label="agent.indentedName"
                  :value="agent.proxyId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row :gutter="24" style="margin-top: 10px">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text87') + '：'"
              class="search-label"
            >
              <el-autocomplete
                v-model="searchForm.symbol"
                :fetch-suggestions="fetchSymbolSuggestions"
                placeholder=""
                clearable
              >
                <template #default="{ item }">
                  <div class="name">{{ item.value }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text94') + '：'"
              class="search-label"
            >
              <el-select clearable v-model="searchForm.bsType" placeholder="">
                <el-option :label="$t('proxy.text96')" value="1" />
                <el-option :label="$t('proxy.text97')" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text98') + '：'"
              class="selector-search-label"
            >
              <el-select clearable v-model="searchForm.isClear" placeholder="">
                <el-option :label="$t('proxy.text100')" value="0" />
                <el-option :label="$t('proxy.text99')" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text113') + '：'"
              class="search-label"
              style="width: 160%"
            >
              <el-date-picker
                v-model="searchForm.openTimeRange"
                type="daterange"
                range-separator="-"
                format="MM/DD/YYYY"
                value-format="YYYY-MM-DD"
                :start-placeholder="$t('proxy.text201')"
                :end-placeholder="$t('proxy.text202')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4" />
        </el-row>

        <!-- 第三行 -->
        <el-row :gutter="24" style="margin-top: 10px">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text114') + '：'"
              class="search-label"
              style="width: 160%"
            >
              <el-date-picker
                v-model="searchForm.closeTimeRange"
                type="daterange"
                range-separator="-"
                format="MM/DD/YYYY"
                value-format="YYYY-MM-DD"
                :start-placeholder="$t('proxy.text201')"
                :end-placeholder="$t('proxy.text202')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="2">
            <el-form-item>
              <el-button
                type="primary"
                @click="onSearch"
                class="search-button"
                >{{ $t("proxy.text13") }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list-spacer"></div>

    <!-- 概览 -->
    <div class="overview-container">
      <span class="summary-title"
        >{{ $t("proxy.text115") }}：<span class="summary-text"
          >{{ summary.profit }} USD</span
        ></span
      >
      <span class="summary-title"
        >{{ $t("proxy.text116") }}：<span class="summary-text"
          >{{ summary.overnightInterest }} USD</span
        ></span
      >
      <span class="summary-title"
        >{{ $t("proxy.text118") }}：<span class="summary-text">{{
          summary.quantity
        }}</span></span
      >
      <span class="summary-title"
        >{{ $t("proxy.text117") }}：<span class="summary-text"
          >{{ summary.commission }} USD</span
        ></span
      >
      <span class="summary-title"
        >{{ $t("proxy.text310") }}：<span class="summary-text"
          >{{ summary.tradeFeeCommission }} USD</span
        ></span
      >
    </div>

    <div class="list-spacer"></div>

    <!-- Tab 切换 -->
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('proxy.text277')" name="webHistory"></el-tab-pane>
      <el-tab-pane :label="$t('proxy.text278')" name="mt4History"></el-tab-pane>
    </el-tabs>

    <!-- 表格和分页容器 -->
    <div class="table-container">
      <!-- 交易记录表格 Web交易历史-->
      <el-table
        :data="filteredData"
        style="width: 100%"
        v-if="activeName === 'webHistory'"
      >
        <el-table-column
          min-width="120px"
          prop="userId"
          :label="$t('proxy.text84')"
          align="center"
        />
        <el-table-column
          min-width="180px"
          prop="proxyName"
          :label="$t('proxy.text62')"
          align="center"
        />
        <el-table-column
          min-width="150px"
          prop="fundAccountName"
          :label="$t('proxy.text88')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.fundAccountName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="250px"
          prop="email"
          :label="$t('proxy.text34')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.email || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="120px"
          prop="phone"
          :label="$t('proxy.text89')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="fundAccountId"
          :label="$t('proxy.text111')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.fundAccountId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="mt4Loginid"
          :label="$t('proxy.text216')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.mt4Loginid || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150px"
          prop="openOrderTypeStr"
          :label="$t('proxy.text169')"
          align="center"
        />
        <el-table-column
          min-width="150px"
          prop="openOrderNo"
          :label="$t('proxy.text221')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.openOrderNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150px"
          prop="closeOrderNo"
          :label="$t('proxy.text222')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.closeOrderNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="symbol"
          :label="$t('proxy.text87')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="bsTypeStr"
          :label="$t('proxy.text94')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="isClearStr"
          :label="$t('proxy.text98')"
          align="center"
        />
        <el-table-column
          min-width="100px"
          prop="quantity"
          :label="$t('followOrder.text11')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="openPrice"
          :label="$t('followOrder.text50')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="closePrice"
          :label="$t('proxy.text126')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="stopProfit"
          :label="$t('proxy.text223')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="stopLoss"
          :label="$t('proxy.text224')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="profit"
          :label="$t('followOrder.text69')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="overnightInterest"
          :label="$t('followOrder.text54')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="fee"
          :label="$t('fundHistory.text43')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="tradeFeeCommission"
          :label="$t('proxy.text307')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="commission"
          :label="$t('trade.text78')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="closeTypeStr"
          :label="$t('proxy.text101')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="firstTradingTime"
          :label="$t('proxy.text113')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="lastTradingTime"
          :label="$t('proxy.text114')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.lastTradingTime || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 交易记录表格 MT4交易历史-->
      <el-table
        :data="filteredData"
        style="width: 100%"
        v-if="activeName === 'mt4History'"
      >
        <el-table-column
          min-width="120px"
          prop="userId"
          :label="$t('proxy.text84')"
          align="center"
        />
        <el-table-column
          min-width="180px"
          prop="proxyName"
          :label="$t('proxy.text62')"
          align="center"
        />
        <el-table-column
          min-width="150px"
          prop="fundAccountName"
          :label="$t('proxy.text88')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.fundAccountName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="250px"
          prop="email"
          :label="$t('proxy.text34')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.email || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="120px"
          prop="phone"
          :label="$t('proxy.text89')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="fundAccountId"
          :label="$t('proxy.text111')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.fundAccountId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="mt4Loginid"
          :label="$t('proxy.text216')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.mt4Loginid || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          min-width="120px"
          prop="openOrderNo"
          :label="$t('proxy.text144')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.openOrderNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="firstTradingTime"
          :label="$t('followOrder.text49')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="bsTypeStr"
          :label="$t('proxy.text94')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="isClearStr"
          :label="$t('proxy.text98')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="quantity"
          :label="$t('followOrder.text11')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="symbol"
          :label="$t('proxy.text87')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="openPrice"
          :label="$t('followOrder.text50')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="stopLoss"
          :label="$t('proxy.text224')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="stopProfit"
          :label="$t('proxy.text223')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="lastTradingTime"
          :label="$t('proxy.text114')"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ row.lastTradingTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="closePrice"
          :label="$t('proxy.text126')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="fee"
          :label="$t('fundHistory.text43')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="tradeFeeCommission"
          :label="$t('proxy.text307')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="overnightInterest"
          :label="$t('proxy.text292')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="profit"
          :label="$t('followOrder.text69')"
          align="center"
        />
        <el-table-column
          min-width="120px"
          prop="commission"
          :label="$t('trade.text78')"
          align="center"
        />
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      @current-change="handlePageChange"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      :page-size="pageSize"
      :total="totalEntries"
      :page-sizes="[10, 50, 100, 200]"
      :disabled="false"
      :background="true"
      layout="total, prev, pager, next, sizes"
      class="pagination-container"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import apiService from "@/api/request";
import { useStore } from "vuex";
const activeName = ref("webHistory");
const searchForm = ref({
  name: "",
  email: "",
  phone: "",
  fundAccountId: "",
  mt4LoginId: "",
  bsType: "",
  isClear: "",
  openTimeRange: [],
  closeTimeRange: [],
  proxyName: "",
  SProxyId: "",
  symbol: "",
});

const summary = ref({
  profit: "--",
  overnightInterest: "--",
  commission: "--",
  rebate: "--",
  tradeFeeCommission: "--",
});
const filteredData = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalEntries = ref(0);
const symbolList = ref([]); // 存储所有交易品种
const agents = ref([]); // 存储所有代理
const agentConfig = computed(() => store.getters.getAgentConfig);
const route = useRoute();
const store = useStore();
// 获取所有代理
const fetchAgents = async () => {
  try {
    const params = {
      containRoot: true,
    };
    const response = await apiService.proxyAllSubProxyList(params);
    agents.value = formatAgents(
      response.data.proxyTree ? response.data.proxyTree : []
    );
    loadRouteParams();
  } catch (error) {
    console.error("获取代理列表失败:", error);
  }
};

const formatAgents = (agentsList, level = 0) => {
  return agentsList.flatMap((agent) => {
    const indentedAgent = {
      proxyId: agent.proxyId,
      indentedName: `${" ㅤ".repeat(level)}${agent.proxyName}`,
    };
    const children = agent.childProxyInfo
      ? formatAgents(agent.childProxyInfo, level + 1)
      : [];
    return [indentedAgent, ...children];
  });
};

// 获取所有交易品种
const fetchSymbols = async () => {
  try {
    const response = await apiService.proxyGetSymbols();
    if (response.status === 1) {
      symbolList.value = response.data.list;
    } else {
      console.error("获取交易品种失败:", response.message);
    }
  } catch (error) {
    console.error("获取交易品种失败:", error);
  }
};

// 动态生成交易品种的匹配选项
const fetchSymbolSuggestions = (queryString, cb) => {
  if (!queryString) {
    // 将 symbolList 转换为包含 `value` 字段的对象数组
    cb(symbolList.value.map((symbol) => ({ value: symbol })));
    return;
  }
  const results = symbolList.value
    .filter((symbol) =>
      symbol.toLowerCase().includes(queryString.toLowerCase())
    )
    .map((symbol) => ({ value: symbol })); // 确保每个选项是一个包含 `value` 属性的对象
  cb(results);
};

const loadRouteParams = () => {
  const { FundAccountId, Name } = route.query;

  if (Name) {
    searchForm.value.name = Name;
  }

  if (FundAccountId) {
    searchForm.value.fundAccountId = FundAccountId;
  }

  // if (SProxyId) {
  //   searchForm.value.SProxyId = parseInt(SProxyId, 10);
  // }
};

const fetchTransactionData = async () => {
  try {
    const userId = route.query.userId || "";
    const type = activeName.value === "webHistory" ? 1 : 2;
    const response = await apiService.proxyTransactionList({
      ...searchForm.value,
      type,
      userId,
      OpenStartTime: searchForm.value.openTimeRange
        ? searchForm.value.openTimeRange.length
          ? searchForm.value.openTimeRange[0]
          : ""
        : "",
      OpenEndTime: searchForm.value.openTimeRange
        ? searchForm.value.openTimeRange.length
          ? searchForm.value.openTimeRange[1]
          : ""
        : "",
      CloseStartTime: searchForm.value.closeTimeRange
        ? searchForm.value.closeTimeRange.length
          ? searchForm.value.closeTimeRange[0]
          : ""
        : "",
      CloseEndTime: searchForm.value.closeTimeRange
        ? searchForm.value.closeTimeRange.length
          ? searchForm.value.closeTimeRange[1]
          : ""
        : "",
      page: currentPage.value,
      limit: pageSize.value,
    });
    filteredData.value = response.data.list;
    totalEntries.value = response.data.count;
    summary.value = {
      profit: response.data.statis.profit || "0.0",
      overnightInterest: response.data.statis.overnightInterest || "0.0",
      commission: response.data.statis.commission || "0.0",
      quantity: response.data.statis.quantity || "0.0",
      tradeFeeCommission: response.data.statis.tradeFeeCommission || "0.0",
    };
  } catch (error) {
    console.error("获取交易记录失败", error);
  }
};

onMounted(() => {
  searchForm.value.fundAccountId = route.query.FundAccountId || "";
  searchForm.value.name = route.query.name || "";
  fetchSymbols();
  fetchAgents();
  fetchTransactionData();
});

const onSearch = () => {
  currentPage.value = 1;
  fetchTransactionData();
};

const handleTabClick = (tab) => {
  activeName.value = tab.props.name;
  fetchTransactionData();
};

const handlePageChange = (page) => {
  currentPage.value = page;
  fetchTransactionData();
};

const handleSizeChange = (size) => {
  pageSize.value = size;
  fetchTransactionData();
};

// 强制设置 Popper 的位置在下方
const popperOptions = {
  placement: "bottom-start",
  modifiers: [
    {
      name: "preventOverflow",
      options: {
        boundary: "window",
      },
    },
    {
      name: "flip",
      enabled: false, // 禁用自动翻转
    },
  ],
};
</script>

<style lang="less" scoped>
.tabs > .el-tabs__content {
  padding: 32px;
  color: @primary-color;
  font-size: 32px;
  font-weight: 600;
}

.tabs {
  padding-left: 20px;
  background-color: @white;
  margin: 0;
}
</style>
